export default function ({ store, redirect }) {
  if (store.getters['user/isPortalUser'] && store.state['user']?.currentLogin?.wealth_enabled === false) {
    return redirect('/');
  }
}
